/**
 * Small helpers shared by Vuex modules that talk to the API.
 */

/** The payload of an API response: a `{ data: ... }` body is unwrapped. */
export function unwrap(res) {
  return res.data && res.data.data ? res.data.data : res.data
}

/**
 * A vue-api-query list request for `Model`, with only the filters that have a
 * value (an empty filter would otherwise be sent as `?q=`).
 */
export function buildListQuery(
  Model,
  filterKeys,
  { filters = {}, page = 1, perPage = 15 } = {},
) {
  const query = Model.page(page).limit(perPage)
  filterKeys.forEach((key) => {
    const value = filters ? filters[key] : undefined
    if (value !== undefined && value !== null && value !== '') {
      query.where(key, value)
    }
  })
  return query
}

/**
 * Run an API call and, when it fails, reject with the axios response. That is
 * the repo convention for store actions, so callers can feed the rejection to
 * `Form.$handleError({ response })`.
 */
export async function rejectWithResponse(call) {
  try {
    return await call()
  } catch (err) {
    throw err.response
  }
}
